<div class="bottom flex justify-content-between custom-footer-wrapper">
    <p>
      Δ/νση Πληροφορικής <a href="https://ekapy.gov.gr/" target="_blank">ΕΚΑΠΥ</a> © {{currentYear}}. Version {{appVersion}}
    </p>
    <p>{{today}}</p>
</div>
